import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "subjectField", "asEmailCheckbox", "notifyEmailCheckbox", "emailFields"];
  static values = {
    name: { type: String, default: "public_note" }
  };

  connect() {
    this.input = this.findCheckbox();
    if (!this.input) {
      console.warn("[public-note] Checkbox input not found. Looking for input[type=checkbox][name=%s].", this.nameValue);
      return;
    }

    this._onChange = () => this.sync();
    this.input.addEventListener("change", this._onChange);

    this.sync();
    this.toggleEmailFields();
  }

  disconnect() {
    if (this.input && this._onChange) {
      this.input.removeEventListener("change", this._onChange);
    }
  }

  toggle() {
    this.sync();
  }

  handleAsEmailChange() {
    if (this.asEmailCheckboxTarget.checked && this.hasNotifyEmailCheckboxTarget) {
      this.notifyEmailCheckboxTarget.checked = false;
    }
    this.toggleEmailFields();
  }

  handleNotifyEmailChange() {
    if (this.notifyEmailCheckboxTarget.checked && this.hasAsEmailCheckboxTarget) {
      this.asEmailCheckboxTarget.checked = false;
    }
    this.toggleEmailFields();
  }

  toggleEmailFields() {
    const asEmailChecked = this.hasAsEmailCheckboxTarget && this.asEmailCheckboxTarget.checked;
    const notifyEmailChecked = this.hasNotifyEmailCheckboxTarget && this.notifyEmailCheckboxTarget.checked;
    const anyChecked = asEmailChecked || notifyEmailChecked;

    if (this.hasEmailFieldsTarget) {
      if (anyChecked) {
        this.emailFieldsTarget.classList.remove("hidden");
        this.emailFieldsTarget.classList.add("flex", "flex-wrap", "gap-16", "items-start");
      } else {
        this.emailFieldsTarget.classList.add("hidden");
        this.emailFieldsTarget.classList.remove("flex", "flex-wrap", "gap-16", "items-start");
      }
    }

    if (this.hasSubjectFieldTarget) {
      const subjectInput = this.subjectFieldTarget.querySelector('input');

      if (asEmailChecked) {
        this.subjectFieldTarget.classList.remove("hidden");
        if (subjectInput) {
          subjectInput.setAttribute("required", "required");
        }
      } else {
        this.subjectFieldTarget.classList.add("hidden");
        if (subjectInput) {
          subjectInput.removeAttribute("required");
        }
      }
    }
  }

  sync() {
    const checked = !!this.input?.checked;

    this.contentTargets.forEach((el) => {
      if (checked) {
        el.classList.remove("hidden", "opacity-0");
        el.classList.add("opacity-100");
        el.setAttribute("aria-hidden", "false");
      } else {
        el.classList.add("opacity-0");
        el.classList.add("hidden");
        el.setAttribute("aria-hidden", "true");
      }

      el.querySelectorAll("input, select, textarea, button").forEach((f) => {
        f.disabled = !checked && f.name !== "public_note";
      });
    });
  }

  findCheckbox() {
    let input = this.element.querySelector(`input[type="checkbox"][name="${this.nameValue}"]`);
    if (input) return input;

    input = this.element.querySelector(`#public_note_option[type="checkbox"]`);
    if (input) return input;

    return this.element.querySelector(`input[type="checkbox"]`);
  }
}
